import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["placeholderText", "searchTheme", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, FormControl, IconButton, Input } from '@mui/material';
import React from 'react';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';

var backgroundColorSwitch = function backgroundColorSwitch(theme) {
  switch (theme) {
    case 'OnPrimary':
      return 'primary.light';

    case 'OnSecondary':
      return 'secondary.light';

    case 'OnWhite':
      return 'background.neutral';

    case 'Minimalist':
      return 'background.white';

    default:
      return 'background.neutral';
  }
};

var paddingSwitchCase = function paddingSwitchCase(theme) {
  switch (theme) {
    case 'Minimalist':
      return {
        sx: {
          pr: '0px',
          pl: '0px'
        },
        startAdornment: null,
        endAdornment: React.createElement(TAGSvgIcon, {
          icon: 'SearchFunc',
          size: 30
        })
      };

    default:
      return {
        sx: {
          pr: '4px',
          pl: '16px'
        },
        startAdornment: React.createElement(Box, {
          sx: {
            mr: 2
          }
        }, React.createElement(TAGSvgIcon, {
          icon: 'SearchFunc',
          size: 30
        })),
        endAdornment: React.createElement(IconButton, {
          sx: {
            p: 1
          }
        }, React.createElement(TAGSvgIcon, {
          icon: 'MicrophoneAlt',
          size: 30
        }))
      };
  }
};

var TAGSearchFieldInput = function TAGSearchFieldInput(_ref) {
  var _sx$color;

  var _ref$placeholderText = _ref.placeholderText,
      placeholderText = _ref$placeholderText === void 0 ? '' : _ref$placeholderText,
      _ref$searchTheme = _ref.searchTheme,
      searchTheme = _ref$searchTheme === void 0 ? 'Default' : _ref$searchTheme,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var iconsAndPadding = paddingSwitchCase(searchTheme);
  return React.createElement(FormControl, {
    fullWidth: true,
    sx: [{
      bgcolor: backgroundColorSwitch(searchTheme),
      borderRadius: '2px'
    }, _objectSpread({}, sx)]
  }, React.createElement(Input, _objectSpread(_objectSpread(_objectSpread({
    placeholder: placeholderText,
    disableUnderline: searchTheme === 'Minimalist' ? false : true
  }, props), iconsAndPadding), {}, {
    sx: [_objectSpread({}, iconsAndPadding.sx), {
      color: (_sx$color = sx === null || sx === void 0 ? void 0 : sx.color) !== null && _sx$color !== void 0 ? _sx$color : 'inherit',
      boxShadow: searchTheme === 'Default' ? '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)' : null,
      borderRadius: '2px',
      py: '12px',
      height: '48px'
    }]
  })));
};

export default TAGSearchFieldInput;